import { render, staticRenderFns } from "./CapsuleIcon.vue?vue&type=template&id=a14934b2&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_Lavoro\\ALCYON\\Homestead\\code\\reporting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a14934b2')) {
      api.createRecord('a14934b2', component.options)
    } else {
      api.reload('a14934b2', component.options)
    }
    module.hot.accept("./CapsuleIcon.vue?vue&type=template&id=a14934b2&", function () {
      api.rerender('a14934b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/icon/CapsuleIcon.vue"
export default component.exports